module.exports = __webpack_public_path__ + "static/media/licniPodaci.d04ce343.svg";